module.exports = __webpack_public_path__ + "images/thumb-c19623201a4528f08fdf833ea053e9aa.jpg";